export const GET_CURRENCIES_INIT = "CURRENCIES:GET_INIT";
export const GET_CURRENCIES_SUCCESS = "CURRENCIES:GET_SUCCESS";
export const GET_CURRENCIES_FAILURE = "CURRENCIES:GET_FAIL";
